import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPaintBucketDrop: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="paint-bucket-drop"><path d="M10.8215 20.4964L20.7559 12.8995L10.8564 3L3.25953 12.9344C2.34617 14.1288 2.45807 15.8149 3.52129 16.8781L6.87785 20.2346C7.94106 21.2978 9.62712 21.4098 10.8215 20.4964Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12.5 11.5L2 6" stroke="currentColor" strokeWidth="1.5"/><path d="M22.5 19.6C22.5 20.9255 21.4926 22 20.25 22C19.0074 22 18 20.9255 18 19.6C18 17.8 20.25 16 20.25 16C20.25 16 22.5 17.8 22.5 19.6Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPaintBucketDrop;
